module.exports = __webpack_public_path__ + "img/artillery_cruiser.cb52b390.jpg";